import InfoMeType from "./actionTypes"



// function that called as action
const getInfoMe = data => ({
  type: InfoMeType.GET_INFO_ME_2,
  payload: data,
})

const getInfoMeSuccess = data => ({
  type: InfoMeType.GET_INFO_ME_2_SUCCESS,
  payload: data,
})



const InfoMeAction = {
  getInfoMe,
  getInfoMeSuccess
}

export default InfoMeAction





